
define('jsx!components/ideas-lab',[
    "jquery",
    "underscore",
    "backbone",
    "react",
    "jsx!components/ideas-lab/ideas-lab-tab",
    "jsx!components/ideas-lab/ideas-lab-search",
    "jsx!components/ideas-lab/ideas-lab-modal",
    "jsx!components/ideas-lab/ideas-lab-content",
    "jsx!components/loadingindicator",
    "shared/connect-to-actions",
    "actions/ideas-lab",
    "shared/client",
    "shared/browser-detect",
    "shared/pendo"
    ], 
    function ($, _, Backbone, React, IdeasLabTab, IdeasLabSearch, IdeasLabModal, IdeasLabContent, LoadingIndicator, ConnectToActions, IdeasLabAction, Client, BrowserDetect, Pendo){
	return React.createClass({
        displayName: "IdeasLab",
        defaultAppLevel: [
            'Elementary School', 
            'Middle School', 
            'High School', 
            'Post Secondary', 
            'Beyond the Classroom',
        ],
		getInitialState: function ()
		{  
            return {
                assetResults: [], // Result array that will hold whatever content shows
                topicAreas: [], // Categories
                
                favorites: [], // Result array that were favorited

                selectedTopicArea: [], // Selected Categories
                selectedAppLevel: [], // Selected Tags
                keywords: [], // Search Results

                isModalOpen: "", // Opened Modal
                isFilterTabOpen: true,
                
                page: 0,
                prevPageLink: "",
                nextPageLink: "",
                meta: {},
                loadMore: false,

                loading: true,
                isBookmarkChecked: false,
                isAllTopicChecked: false,
                isAllAppChecked: false,
            }
        },
        componentDidMount: function ()
        {
            var self = this;
            this.actions = {"ideas-lab" : new IdeasLabAction()};
            var actionIdeaslab = ConnectToActions["ideas-lab"];
            // Get all Cateogries and pull the assets for the categories.
            $.get(Client.getAPIURL() + "/media/buncee/categories", {"asset_type": "idea"}, {}, "json"
            ).done(function (response) {
                    self.setState({
                        topicAreas: response.data,
                    });
                    actionIdeaslab.pull(function (response) {
                        self.resetPage(response);
                    }, function () {self.setState({assetResults: []})});
                }
            );
            if (window.appData.user) {
                actionIdeaslab.getBookmarked(function (favorites) {
                    self.setState({
                        favorites: favorites.data,
                    });
                });
            }
            if (BrowserDetect.isMobileStrict()) {
                window.addEventListener("orientationchange", function() {
                    self.forceUpdate();
                });
            }
            // olark("api.box.hide"); // TODO fix olark hiding

            /**
             * Initialize Pendo once ideas-lab page is mounted on DOM
             * @author Dale Kelly
             * @dateCreated 01/18/2021
             */
            var pendo = window.pendo;
            var user = window.appData.user.data;
            if (pendo && user) {
                Pendo.init(pendo);
            }
        },
		componentDidUpdate: function (prevProps, prevState)
		{
            var self =this;
            this.actions = {"ideas-lab" : new IdeasLabAction()};
            var actionIdeaslab = ConnectToActions["ideas-lab"];
            
            if (this.onFilterChangeRender(prevState)) {
                this.setState({loading: true});
                actionIdeaslab.pullWithFilters(this.state.selectedTopicArea, this.state.selectedAppLevel ,this.state.keywords, this.state.isBookmarkChecked, function (response) {
                    self.resetPage(response);
                }, function () {self.setState({assetResults: [], loading:false})});
            }
            if (prevState.isBookmarkChecked !== this.state.isBookmarkChecked) {
                this.setState({loading: true});
                actionIdeaslab.getBookmarked(function (favorites) {
                    self.setState({
                        favorites: favorites.data,
                    });
                })
            }
        },
        onFilterChangeRender: function (prevState) {
            if ((prevState.selectedTopicArea !== this.state.selectedTopicArea && (this.state.selectedTopicArea.length + this.state.selectedAppLevel.length) === 0)) {
                return true;
            } else if ((prevState.selectedAppLevel !== this.state.selectedAppLevel && (this.state.selectedTopicArea.length + this.state.selectedAppLevel.length) === 0)) {
                return true;
            } else if (prevState.selectedTopicArea !== this.state.selectedTopicArea) {
                return true;
            } else if (prevState.selectedAppLevel !== this.state.selectedAppLevel) {
                return true;
            } else if (prevState.keywords !== this.state.keywords) {
                return true;
            }
            return false;
        },
        onThumbnailClick: function (tabGuid) {
            this.setState({
                isModalOpen: tabGuid,
            });
        },
        onBookmarkedClick: function () {
            var self = this;
            ConnectToActions["ideas-lab"].getBookmarked(function (favorites) {
                self.setState({
                    favorites: favorites.data,
                });
            });
        },
        onScrollBottom: function () {
            var self = this;
            if(BrowserDetect.isMobileStrict()){

                var scrollingElem = document.getElementById("ideas-lab-content");
                if (scrollingElem) {
                    if (scrollingElem.scrollHeight - 300 <= scrollingElem.scrollTop + scrollingElem.offsetHeight ) {
                        if (this.state.assetResults !== null && this.state.assetResults.length > 0 && !this.state.loadMore) {
                            if (this.state.nextPageLink){
                                this.setState({loadMore:true});
                                $.get(this.state.nextPageLink, {}, {}, "json"
                                ).done(function (response) {
                                    self.setState({
                                        assetResults: self.state.assetResults.concat(response.data),
                                        nextPageLink: response.links.next_page,
                                        prevPageLink: response.links.prev_page,
                                        loading: false,
                                        page: self.state.page + 1, 
                                        meta: response.meta,
                                        loadMore: false,
                                    });
                                });
                            }
                        }
                    }
                }
            } else {
                var scrollingElem = document.getElementById("ideas-lab-content");
                var header = document.getElementById("ideaslab-navbar");

                if (scrollingElem && header) {
                    if (scrollingElem.scrollTop + 50> header.offsetTop) {
                        header.classList.add("fixed");
                    } else {
                        header.classList.remove("fixed");
                    }
                }
            }
        },
        trackIdea: function(guid, context) {
            if(window.appData.user && window.appData.user.access_token) {
                promise = $.ajax({
                    url: window.appData.client.api_url + "/media/buncee/track",
                    type: 'POST',
                    data: {
                        context:context,
                        asset_guid: guid,
                    },
                    headers: {
                        'Authorization': "Bearer " + window.appData.user.access_token,
                    },
                    dataType: 'json',
                });
            }
        },
        closeModal: function () {
            this.setState({
                isModalOpen: "",
            });
        },
        showMoreLess: function () {
            this.setState({
                isFilterTabOpen: !this.state.isFilterTabOpen
            });
        },
        showSidebar: function () { 
            if (!document.getElementById("sidebar").style.left) {
                document.getElementById("sidebar").style.left = 0;
                document.getElementById("mobile-search-button").className = "icons8-close";
            } else if (document.getElementById("sidebar").style.left === "0px"){
                document.getElementById("sidebar").style.left = "-270px";
                document.getElementById("mobile-search-button").className = "icons8-search";
            } else {
                document.getElementById("sidebar").style.left = 0;
                document.getElementById("mobile-search-button").className = "icons8-close";
            }
        },
        resetPage: function (response) {
            this.setState({
                assetResults: response.data,
                nextPageLink: response.links.next_page,
                prevPageLink: response.links.prev_page,
                loading: false,
                meta: response.meta,
                page: 0,
            });
        },
        updateSelectedTopicLevel: function (topicId) {
            if (topicId === "all") {
                this.setState({
                    selectedTopicArea: [],
                    isAllTopicChecked: false,
                })
                return;
            }
            
            if (Array.isArray(topicId)) {
                this.setState({
                    selectedTopicArea: topicId,
                    isAllTopicChecked: !this.state.isAllTopicChecked,
                })
                return;
            }

            tempCategories = this.state.selectedTopicArea.slice();
            if(_.indexOf(tempCategories, topicId) > -1) {
                tempCategories =_.without(tempCategories, topicId);
                this.setState({
                    selectedTopicArea: tempCategories,
                    isAllTopicChecked: false,
                })
            } else {
                tempCategories.push(topicId);
                this.setState({
                    selectedTopicArea: tempCategories,
                    isAllTopicChecked: tempCategories.length === this.state.topicAreas.length ? true : false,
                });
            }
        },
        updateSelectedAppLevel: function (value) {
            if (value === "all") {
                this.setState({
                    selectedAppLevel: [],
                    isAllAppChecked: false,
                })
                return;
            }

            if (Array.isArray(value)) {
                this.setState({
                    selectedAppLevel: value,
                    isAllAppChecked: !this.state.isAllAppChecked,
                })
                return;
            }
            tempCategories = this.state.selectedAppLevel.slice();
            if(_.indexOf(tempCategories, value) > -1) {
                tempCategories =_.without(tempCategories, value);
                this.setState({
                    selectedAppLevel: tempCategories,
                    isAllAppChecked: false,
                })
            } else {
                tempCategories.push(value);
                this.setState({
                    selectedAppLevel: tempCategories,
                    isAllAppChecked: tempCategories.length === this.defaultAppLevel.length ? true : false,
                });
            }
        },
        updatedKewords: function (value) {
            if (value.length === 0) {
                this.setState({
                    keywords: [],
                });
                return;
            }

            tempKeywords = [];
            tempKeywords.push(value);
            this.setState({
                keywords: tempKeywords,
            });
        },
        updateDefaultCheckbox: function (value, status) {
            var self = this;
            if (value === "all") {
                if (!status) {
                    this.setState({
                        selectedAppLevel: [],
                        selectedTopicArea: [],
                        isAllAppChecked: false,
                        isAllTopicChecked: false,
                        loading: true,
                    })
                    ConnectToActions["ideas-lab"].pullWithFilters(this.state.selectedTopicArea, this.state.selectedAppLevel ,this.state.keywords, this.state.isBookmarkChecked, function (response) {
                        self.resetPage(response);
                    }, function () {self.setState({assetResults: [], loading:false})});
                }
            } else if (value === "bookmarked"){
                if (!status) {
                    this.setState({
                        assetResults: [],
                        isBookmarkChecked: !status,
                        loading: true,
                    });
                    ConnectToActions["ideas-lab"].pullWithFilters(this.state.selectedTopicArea ,this.state.selectedAppLevel, this.state.keywords, !status, function (response) {
                        self.resetPage(response);
                    });
                } else {
                    this.setState({
                        isBookmarkChecked: !status,
                        loading: true,
                    })
                    ConnectToActions["ideas-lab"].pullWithFilters(this.state.selectedTopicArea ,this.state.selectedAppLevel, this.state.keywords, !status, function (response) {
                        self.resetPage(response);
                    });
                }
            }
        },
        clearSearch: function() {
            $('#ideas-lab-input').val('');
            this.setState({keywords: []});
        },
        goToPage: function(page) {
            var self = this;
            if (page === "prev" && this.state.prevPageLink) {
                this.setState({loading: true});
                $.ajax({
					url: this.state.prevPageLink,
					type: 'GET',
					headers: window.appData.user ? {
						'Authorization': "Bearer " + window.appData.user.access_token,
					} : {},
				}).done(function (response) {
                    self.setState({
                        assetResults: response.data,
                        nextPageLink: response.links.next_page,
                        prevPageLink: response.links.prev_page,
                        page: self.state.page - 1, 
                        loading: false,
                        meta: response.meta,
                    });
                });
            } else if (this.state.nextPageLink){
                this.setState({loading: true});
                $.ajax({
					url: this.state.nextPageLink,
					type: 'GET',
					headers: window.appData.user ? {
						'Authorization': "Bearer " + window.appData.user.access_token,
					} : {},
				}).done(function (response) {
                    self.setState({
                        assetResults: response.data,
                        nextPageLink: response.links.next_page,
                        prevPageLink: response.links.prev_page,
                        loading: false,
                        page: self.state.page + 1, 
                        meta: response.meta,
                    });
                });
            }
        },
        renderKeywordsTagBar: function () {
            var self = this;
            var keywordsTag = [];

            if (!this.state.isFilterTabOpen) {
                return(
                    React.createElement("div", {className: "content-navbar-above"}, 
                        React.createElement("div", {className: "filter-tags all showall"}, React.createElement("span", {onClick: this.showMoreLess}, " Show All Tags "))
                    )
                );
            }

            if (this.state.keywords.length > 0) {
                keywordsTag = _.map(self.state.keywords, function (value) {
                    return (
                        React.createElement("div", {className: "filter-tags keywords"}, 
                            value, 
                            React.createElement("span", {className: "icons8-close remove-filter", onClick: self.clearSearch})
                        )
                    );
                });
                return ( 
                    React.createElement("div", {className: "content-navbar-above"}, 
                         keywordsTag 
                    )
                );
            } else if(this.state.selectedAppLevel.length > 0 || this.state.selectedTopicArea.length > 0) {
                return null;
            } else {
                return (
                    React.createElement("div", {className: "content-navbar-above"}, 
                        React.createElement("div", {className: "filter-tags all"}, React.createElement("span", null, " All "))
                    )
                );
            }
        },
        renderTopicTagBar: function () {
            var self = this;
            var topicaAreaTag = [];

            if (!this.state.isFilterTabOpen) {
                return null;
            }

            if (this.state.selectedTopicArea.length > 0) {
                if (this.state.selectedTopicArea.length === this.state.topicAreas.length) {
                    topicaAreaTag = 
                        (React.createElement("div", {className: "filter-tags topic"}, 
                            "All Topic Areas", 
                            React.createElement("span", {className: "icons8-close remove-filter", onClick: function()  {return self.updateSelectedTopicLevel("all");}})
                        ));
                } else {
                    topicaAreaTag = _.map(self.state.selectedTopicArea, function (topicId) {
                        return (
                            React.createElement("div", {className: "filter-tags topic"}, 
                                  _.find(self.state.topicAreas, function (topic) {
                                    return topic.guid === topicId;
                                }).name, 
                                React.createElement("span", {className: "icons8-close remove-filter", onClick: function()  {return self.updateSelectedTopicLevel(topicId);}})
                            )
                        );
                    });
                }
                return ( 
                    React.createElement("div", {className: "content-navbar-below"}, 
                         topicaAreaTag 
                    )
                );
            } else {
                return null;
            }
        },
        renderAppLevelTagBar: function () {
            var self = this;
            appLevelTag = [];

            if (!this.state.isFilterTabOpen) {
                return null;
            }

            if (this.state.selectedAppLevel.length > 0) {
                if (this.state.selectedAppLevel.length === this.defaultAppLevel.length) {
                    appLevelTag =                     
                        (React.createElement("div", {className: "filter-tags application-level"}, 
                            "All Grade Levels", 
                            React.createElement("span", {className: "icons8-close remove-filter", onClick: function()  {return self.updateSelectedAppLevel("all");}})
                        ));
                } else {
                    appLevelTag = _.map(self.state.selectedAppLevel, function (value) {
                        return (
                        React.createElement("div", {className: "filter-tags application-level"}, 
                             value, 
                            React.createElement("span", {className: "icons8-close remove-filter", onClick: function() {return self.updateSelectedAppLevel(value);}})
                        ) );
                    });
                }
            return (
                React.createElement("div", {className: "content-navbar-below"}, 
                     appLevelTag 
                ));
            } else {
                return null;
            }
        },
        renderContent: function() {
            if (this.state.loading) {
                return React.createElement(LoadingIndicator, {withBackground: false});
            } else if (this.state.assetResults.length > 0) {
                return React.createElement(IdeasLabContent, {
                    results: this.state.assetResults, 
                    onClick: this.onThumbnailClick, 
                    favorites: this.state.favorites, 
                    onBookmarkedClick: this.onBookmarkedClick, 
                    trackIdea: this.trackIdea}

                ) 
            } else {
                return React.createElement("div", {className: "no-content"}, "No results were found!")
            }
        },
        render: function ()
		{
            var self = this;

            var prevPageClassName = this.state.prevPageLink ? "icons8-nav-left" : "icons8-nav-left disable";
            var nextPageClassName = this.state.nextPageLink ? "icons8-nav-right" : "icons8-nav-right disable"; 
            
            var pageStartCount = 25 * this.state.page + 1;
            var pageEndCount = 25 * (this.state.page + 1);

            if (pageEndCount > this.state.meta.num_results) {
                pageEndCount = this.state.meta.num_results;
            }

            var isMobileLandscape = BrowserDetect.isMobileStrict() && (window.orientation && (window.orientation === 90 || window.orientation === -90)) ? "buncee-landscape-overlay visible" : "buncee-landscape-overlay hide";
            
            const paginationSetting = ["pagination"];
            // If there are no results, hide pagination
            if (this.state.assetResults.length === 0) {
                paginationSetting.push("hidden");
            }

            return (
				React.createElement("div", {className: "section ideas-lab"}, 
                    React.createElement("div", {id: "buncee-modal"}), 
                    React.createElement("div", {className: isMobileLandscape}, 
                        React.createElement("div", {className: "overlay-text"}, 
                            "Please rotate your device"
                        )
                    ), 
                    React.createElement("div", {className: "icons8-search", id: "mobile-search-button", onClick: this.showSidebar}), 
                    React.createElement("div", {className: "ideas-lab-sidebar", id: "sidebar"}, 
                        React.createElement(IdeasLabSearch, {updatedKewords: this.updatedKewords}), 
                        React.createElement(IdeasLabTab, {
                            updateDefaultCheckbox: this.updateDefaultCheckbox, 
                            
                            topicAreas: this.state.topicAreas, 
                            updateSelectedTopicLevel: this.updateSelectedTopicLevel, 
                            selectedTopicArea: this.state.selectedTopicArea, 
                            
                            defaultAppLevel: this.defaultAppLevel, 
                            updateSelectedAppLevel: this.updateSelectedAppLevel, 
                            selectedAppLevel: this.state.selectedAppLevel, 

                            isAllTopicChecked: this.state.isAllTopicChecked, 
                            isAllAppChecked: this.state.isAllAppChecked, 

                            favorites: this.state.favorites}
                        )
                    ), 
                    React.createElement("div", {className: "ideas-lab-content", id: "ideas-lab-content", onScroll: this.onScrollBottom}, 
                        React.createElement("div", {className: "content-header"}, 
                            React.createElement("div", {onClick: function()  {return location.reload();}, style: {cursor: "pointer", width: "300px"}}, 
                                React.createElement("object", {id: "ideas-lab-logo", type: "image/svg+xml", data: Client.assetURL('/images/ideas-lab/buncee_ideaslab_logo.svg')})
                            ), 
                            React.createElement("p", null, " Inspiration for everyone from Teachers, to Students, to Administrators. Learn how to create great Buncees - from lesson plans to book journals and more." + ' ' + 
                                "Explore our library for activities to help innovate learning at your school."
                            ), 
                            React.createElement("div", {className: "content-navbars", id: "ideaslab-navbar"}, 
                                React.createElement("div", {className: this.state.isFilterTabOpen ? "filters" : "filters closed"}, 
                                     this.renderKeywordsTagBar(), 
                                     this.renderTopicTagBar(), 
                                     this.renderAppLevelTagBar() 
                                ), 
                                React.createElement("div", {className: this.state.isFilterTabOpen ? "icons8-show-less": "icons8-show-more", onClick: this.showMoreLess}), 
                                React.createElement("div", {className: paginationSetting.join(" ")}, 
                                    React.createElement("div", {className: "page-count"}, " ", pageStartCount, " - ", pageEndCount, " of ", self.state.meta.num_results), 
                                    React.createElement("div", {className: this.state.loading ? prevPageClassName + " disable" : prevPageClassName, onClick: function()  {return this.goToPage("prev");}.bind(this)}), 
                                    React.createElement("div", {className: this.state.loading ? nextPageClassName + " disable" : nextPageClassName, onClick: function()  {return this.goToPage("next");}.bind(this)})
                                )
                            )
                        ), 
                        
                            this.renderContent(), 
                        
                         !this.state.loading && !BrowserDetect.isMobileStrict() ?
                            React.createElement("div", {className: paginationSetting.join(" ").concat(" bottom")}, 
                                React.createElement("div", {className: this.state.loading ? prevPageClassName + " disable" : prevPageClassName, onClick: function()  {return this.goToPage("prev");}.bind(this)}), 
                                React.createElement("div", {className: "page-count"}, " ", pageStartCount, " - ", pageEndCount, " of ", self.state.meta.num_results), 
                                React.createElement("div", {className: this.state.loading ? nextPageClassName + " disable" : nextPageClassName, onClick: function()  {return this.goToPage("next");}.bind(this)})
                            ) : null, 
                        
                        this.state.loadMore ? React.createElement(LoadingIndicator, {withBackground: false}) : null
                    ), 
                    
                        this.state.isModalOpen ? 
                            React.createElement(IdeasLabModal, {
                                closeModal: this.closeModal, 
                                buncee: _.find(this.state.assetResults, function (result) {
                                    return result.id === self.state.isModalOpen;
                                }), 
                                favorites: this.state.favorites, 
                                onBookmarkedClick: this.onBookmarkedClick, 
                                trackIdea: this.trackIdea}
                            ) : null
                    
                )
			);
		}
	});
});
